export const GET_DETAILS = 'GET_DETAILS';
export const GET_PENDING = 'GET_PENDING';
export const GET_REJECTED = 'GET_REJECTED';
export const UPDATE_DETAILS = 'UPDATE_DETAILS';
export const UPDATE_REJECTED = 'UPDATE_REJECTED';
export const UPDATE_PENDING = 'UPDATE_PENDING';
export const INSTA_RES = 'INSTA_RES';
export const RESET_INSTA_FILES = 'RESET_INSTA_FILES';

export const UPDATE_AUTOMATED_SETTING_START = 'UPDATE_AUTOMATED_SETTING_START';
export const UPDATE_AUTOMATED_SETTING_SUCCESS =
    'UPDATE_AUTOMATED_SETTING_SUCCESS';
export const UPDATE_AUTOMATED_SETTING_ERROR = 'UPDATE_AUTOMATED_SETTING_ERROR';

export const GET_AUTOMATED_SETTING_START = 'GET_AUTOMATED_SETTING_START';
export const GET_AUTOMATED_SETTING_SUCCESS = 'GET_AUTOMATED_SETTING_SUCCESS';
export const GET_AUTOMATED_SETTING_ERROR = 'GET_AUTOMATED_SETTING_ERROR';
export const GET_PRICING_START = 'GET_PRICING_START';
export const GET_PRICING_SUCCESS = 'GET_PRICING_SUCCESS';
export const GET_PRICING_ERROR = 'GET_PRICING_ERROR';

export const GET_COUNTRY_SPEC_PENDING = 'GET_COUNTRY_SPEC_PENDING';
export const GET_COUNTRY_SPEC_SUCCESS = 'GET_COUNTRY_SPEC_SUCCESS';
export const GET_COUNTRY_SPEC_REJECTED = 'GET_COUNTRY_SPEC_REJECTED';

export const CONNECT_ACCOUNT_PENDING = 'CONNECT_ACCOUNT_PENDING';
export const CONNECT_ACCOUNT_SUCCESS = 'CONNECT_ACCOUNT_SUCCESS';
export const CONNECT_ACCOUNT_REJECTED = 'CONNECT_ACCOUNT_REJECTED';

export const CONNECT_ACCOUNT_STATUS_PENDING = 'CONNECT_ACCOUNT_STATUS_PENDING';
export const CONNECT_ACCOUNT_STATUS_SUCCESS = 'CONNECT_ACCOUNT_STATUS_SUCCESS';
export const CONNECT_ACCOUNT_STATUS_REJECTED =
    'CONNECT_ACCOUNT_STATUS_REJECTED';

export const GET_CONNECT_ACCOUNT_PENDING = 'GET_CONNECT_ACCOUNT_PENDING';
export const GET_CONNECT_ACCOUNT_SUCCESS = 'GET_CONNECT_ACCOUNT_SUCCESS';
export const GET_CONNECT_ACCOUNT_REJECTED = 'GET_CONNECT_ACCOUNT_REJECTED';

export const GET_STRIPE_SUBSCRIPTION_STATUS_PENDING =
    'GET_STRIPE_SUBSCRIPTION_STATUS_PENDING';
export const GET_STRIPE_SUBSCRIPTION_STATUS_SUCCESS =
    'GET_STRIPE_SUBSCRIPTION_STATUS_SUCCESS';
export const GET_STRIPE_SUBSCRIPTION_STATUS_REJECTED =
    'GET_STRIPE_SUBSCRIPTION_STATUS_REJECTED';

export const CREATE_STRIPE_CHECKOUT_SESSION_PENDING =
    'CREATE_STRIPE_CHECKOUT_SESSION_PENDING';
export const CREATE_STRIPE_CHECKOUT_SESSION_SUCCESS =
    'CREATE_STRIPE_CHECKOUT_SESSION_SUCCESS';
export const CREATE_STRIPE_CHECKOUT_SESSION_REJECTED =
    'CREATE_STRIPE_CHECKOUT_SESSION_REJECTED';
export const CREATE_STRIPE_CHECKOUT_SESSION_RESET =
    'CREATE_STRIPE_CHECKOUT_SESSION_RESET';

export const PREVIEW_STRIPE_PLAN_CHANGE_PENDING =
    'PREVIEW_STRIPE_PLAN_CHANGE_PENDING';
export const PREVIEW_STRIPE_PLAN_CHANGE_SUCCESS =
    'PREVIEW_STRIPE_PLAN_CHANGE_SUCCESS';
export const PREVIEW_STRIPE_PLAN_CHANGE_REJECTED =
    'PREVIEW_STRIPE_PLAN_CHANGE_REJECTED';
export const PREVIEW_STRIPE_PLAN_CHANGE_RESET =
    'PREVIEW_STRIPE_PLAN_CHANGE_RESET';

export const RESUME_STRIPE_SUBSCRIPTION_PENDING =
    'RESUME_STRIPE_SUBSCRIPTION_PENDING';
export const RESUME_STRIPE_SUBSCRIPTION_SUCCESS =
    'RESUME_STRIPE_SUBSCRIPTION_SUCCESS';
export const RESUME_STRIPE_SUBSCRIPTION_REJECTED =
    'RESUME_STRIPE_SUBSCRIPTION_REJECTED';

export const CANCEL_STRIPE_DOWNGRADE_PENDING =
    'CANCEL_STRIPE_DOWNGRADE_PENDING';
export const CANCEL_STRIPE_DOWNGRADE_SUCCESS =
    'CANCEL_STRIPE_DOWNGRADE_SUCCESS';
export const CANCEL_STRIPE_DOWNGRADE_REJECTED =
    'CANCEL_STRIPE_DOWNGRADE_REJECTED';

export const CANCEL_STRIPE_SUBSCRIPTION_PENDING =
    'CANCEL_STRIPE_SUBSCRIPTION_PENDING';
export const CANCEL_STRIPE_SUBSCRIPTION_SUCCESS =
    'CANCEL_STRIPE_SUBSCRIPTION_SUCCESS';
export const CANCEL_STRIPE_SUBSCRIPTION_REJECTED =
    'CANCEL_STRIPE_SUBSCRIPTION_REJECTED';
